<template>
  <div id="app">
    <si-navbar />
    <si-consent />
    <router-view />
    <si-copyright />
  </div>
</template>

<script>
import Consent from "@/components/Consent";
import Copyright from "@/components/Copyright";
import Navbar from "@/components/Navbar";

export default {
  name: "App",
  components: {
    "si-consent": Consent,
    "si-copyright": Copyright,
    "si-navbar": Navbar,
  },
  methods: {
    setDocumentTitle() {
      document.title = "Shark Investing - Active Trader";
    },
    setMetaThemeColor() {
      const metaThemeColor = document.querySelector("meta[name=theme-color]");
      metaThemeColor.setAttribute("content", "#004093");
    },
  },
  mounted() {
    this.setDocumentTitle();
    this.setMetaThemeColor();
  }
};
</script>
